import {horizonSessionStorage} from '../../../utils/local-storage';

/**
 * Utility functions for IntelAcknowledgeButton component
 */

export const STORAGE_KEY = 'intelDontShowAgain';

/**
 * Clears the "Don't show again" sessionStorage preference
 * Should be called on logout to ensure clean session state
 */
export function clearIntelAcknowledgeSessionStorage() {
  horizonSessionStorage.removeItem(STORAGE_KEY);
}
